import React, { useContext, useEffect, useState, useRef } from "react";
import SearchCustomerFeedbackReq from "../../../../Requests/CustomerFeedback/SearchCustomerFeedbackReq";
import CustomerFeedbackApi from "../../../../API/CustomerFeedbackApi";
import VideoReview from "./../../CustomerFeedback/components/VideoReview";
import WrittenReview from "./../../CustomerFeedback/components/WrittenReview";
import SpeedTestReview from "./../../CustomerFeedback/components/SpeedTestReview";
import { A11y, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "./ReviewComponent.scss";
import "swiper/css";
import "swiper/css/pagination";
import { CircularProgress } from "@mui/material";
import { UserContext } from "../../../../App";
import { FaStar } from "react-icons/fa";
import greyUser from "../../../../assets/images/userGrey.png";
import { set } from "lodash";

const ReviewContainer = ({
  searchArea,
  salesRepId,
  type,
  fidiumCustomerIds,
  user,
  customerFeedback,
}) => {
  const [reviews, setReviews] = useState([]);
  const [reviewType, setReviewType] = useState(type || "Written");
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(true);
  const [allReviews, setAllReviews] = useState(true);
  const [totalItems, setTotalItems] = useState(0);
  const swiperRef = useRef(null);
  const [activeGroup, setActiveGroup] = useState(0);
  const maxDots = 5;

  // Cache object to store API responses
  const reviewCache = useRef({});

  const handleFilterChange = (isAllReviews) => {
    setAllReviews(isAllReviews);
    setPageNumber(1);
    setReviews([]);
    setTotalItems(0);
    setHasMore(true);
    if (swiperRef.current) {
      swiperRef.current.slideTo(0); // Reset Swiper to the first slide
    }
  };

  const getReviews = async () => {
    setLoading(true);

    // Generate a unique cache key based on request parameters
    const cacheKey = JSON.stringify({
      searchArea,
      fidiumCustomerIds,
      allReviews,
      salesRepId,
      pageNumber,
      reviewType,
    });

    // Check if the response is already cached
    if (reviewCache.current[cacheKey]) {
      const cachedResponse = reviewCache.current[cacheKey];
      const uniqueReviews = [
        ...new Map(
          [...reviews, ...cachedResponse.list].map((item) => [item.id, item])
        ).values(),
      ];
      setReviews(uniqueReviews);
      setTotalItems(cachedResponse.totalItems);
      setHasMore(cachedResponse.totalPages > pageNumber);
      setLoading(false);
      return;
    }

    const req = new SearchCustomerFeedbackReq();
    if (searchArea) req.area = searchArea;
    if (fidiumCustomerIds) req.fidiumCustomerIds = fidiumCustomerIds;
    if (!allReviews) req.salesRepId = user?.id;
    if (!allReviews && salesRepId) req.salesRepId = salesRepId;
    req.pagingParams.pageNumber = pageNumber;
    req.pagingParams.pageSize = 5;
    req.feedbackType = reviewType;

    const res = await CustomerFeedbackApi.SearchCustomerFeedbacks(req);

    if (res?.status?.success) {
      const list = res.data.list;
      const filteredList =
        customerFeedback && pageNumber === 1
          ? list.filter(
              (review) =>
                customerFeedback?.[0]?.id &&
                review.id !== customerFeedback[0].id
            )
          : list;

      let finalList =
        pageNumber === 1 && customerFeedback
          ? // && filteredList.length < list.length
            [customerFeedback?.[0], ...filteredList]
          : [...reviews, ...filteredList];
      if(allReviews === false) {
        finalList = finalList.filter((item) => item.salesRepId === user?.id);
      }
      // Filter out duplicate reviews
      const uniqueReviews = [
        ...new Map(finalList.map((item) => [item.id, item])).values(),
      ];

      // Cache the response
      reviewCache.current[cacheKey] = {
        list: uniqueReviews,
        totalItems: res.data.totalItems,
        totalPages: res.data.totalPages,
      };

      setReviews(uniqueReviews);
      setTotalItems(res.data.totalItems);
      setHasMore(res.data.totalPages > pageNumber);
    } else {
      console.error(res);
    }
    setLoading(false);
    if (swiperRef.current) swiperRef.current.update();
  };

  useEffect(() => {
    setReviews([]);
    setTotalItems(0);
    setHasMore(true);
    if (pageNumber === 1) {
      getReviews();
    } else {
      setPageNumber(1);
    }
  }, [reviewType, allReviews]);

  useEffect(() => {
    getReviews();
  }, [pageNumber]);

  return (
    <div className="main_review">
      <div className="filter">
        <div
          className="top_filter_buttons"
          style={{ gridTemplateColumns: "1fr 1fr" }}
        >
          <button
            className={allReviews ? "active" : ""}
            onClick={() => handleFilterChange(true)}
          >
            Company
          </button>
          <button
            className={!allReviews ? "active" : ""}
            onClick={() => handleFilterChange(false)}
          >
            My Reviews
          </button>
        </div>
        {!loading && (
          <p
            style={{
              color: "var(--primary-color)",
              fontSize: "1.2rem",
              fontWeight: "bold",
            }}
          >
            Total Reviews: {totalItems}
          </p>
        )}
      </div>

      <Swiper
        modules={[A11y, Pagination]}
        spaceBetween={10}
        slidesPerView={1} // Ensure one slide per view
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
        onSlideChange={(swiper) => {
          const newIndex = swiper.realIndex;
          const isLastSlide = newIndex === swiper.slides.length - 1;

          if (isLastSlide && hasMore && !loading) {
            setPageNumber((prev) => prev + 1);
          }
          const current = swiper.activeIndex;
          console.log(current);
          // Get all bullets
          const bullets = document.querySelectorAll(
            ".swiper-pagination-bullet"
          );
          const total = reviews.length;
          // Reset all bullets
          bullets.forEach((bullet) => {
            bullet.classList.remove("swiper-pagination-bullet-active");
          });

          // Set active bullet based on position
          bullets[current % 5]?.classList.add(
            "swiper-pagination-bullet-active"
          );

          // setActiveGroup(Math.floor(newIndex / 5));
        }}
        pagination={{
          clickable: true,
          renderBullet: (index, className) => {
            // Ensure only 5 dots are displayed
            if (index < Math.min(reviews.length, 5)) {
              return `<span key=${index % 5} class="${className}"></span>`;
            }
            return "";
          },
        }}
        className="slider_review"
      >
        {reviews?.length > 0
          ? reviews.map((review, index) => (
              <SwiperSlide key={index}>
                {review?.feedbackType === "Video" && (
                  <VideoReview review={review} />
                )}
                {review?.feedbackType === "Written" && (
                  <WrittenReview review={review} />
                )}
                {review?.feedbackType === "SpeedTest" && (
                  <SpeedTestReview review={review} />
                )}
              </SwiperSlide>
            ))
          : !loading && (
              <SwiperSlide>
                <div className="no-reviews">No Reviews Available</div>
              </SwiperSlide>
            )}
      </Swiper>
    </div>
  );
};

export default ReviewContainer;
